import toast from "react-hot-toast";
import * as api from "../Api/index";

export const getCategory = () => async (dispatch) => {
  try {
    const { data } = await api.getCategory();
    dispatch({ type: "GET_CATEGORIES_ALL", payload: data });
  } catch (error) {}
};

export const createCategory = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Create category....");
    const { data } = await api.createCategory(postData);
    dispatch({ type: "CREATE_CATEGORY", payload: data });
    toast.remove(creatingId);
    toast.success("Category created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const deleteCategory = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting Category....");
    await api.deleteCategory(id);
    dispatch({ type: "DELETE_CATEGORY", payload: id });
    toast.remove(deletingId);
    toast.success("Category deleted successfully");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
export const updateCategory = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Updating Category....");
    await api.updateCategory(id, postData);
    dispatch({ type: "UPDATE_CATEGORY", payload: id });
    toast.remove(updatingId);
    toast.success("Category updated successfully");
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};
